import { EFinixTransactionType, schemes, zSchema } from "@zeal/common";

export const createFinixTransactionRequestSchema = zSchema
  .object({
    companyID: schemes.uuid(),
    customerAccountID: schemes.uuid(),
    orderID: schemes.uuid().optional(),
    invoiceID: schemes.uuid().optional(),
    amount: zSchema.number(),
    description: zSchema.string(),
    cardID: schemes.uuid(),
    transactionType: zSchema.nativeEnum(EFinixTransactionType),
    transactionRecordID: schemes.uuid(),
    sessionKey: zSchema.string().optional(),
    testMode: zSchema.boolean().optional(),
  })
  .refine(
    (data) => {
      if (
        data.transactionType === EFinixTransactionType.Order &&
        !data.orderID
      ) {
        return false;
      }
      return true;
    },
    {
      message: "orderID is required when transactionType is 'order'",
    }
  )
  .refine(
    (data) => {
      if (
        data.transactionType === EFinixTransactionType.Invoice &&
        !data.invoiceID
      ) {
        return false;
      }
      return true;
    },
    {
      message: "invoiceID is required when transactionType is 'invoice'",
    }
  );

export type TCreateFinixTransactionRequestSchema = zSchema.infer<
  typeof createFinixTransactionRequestSchema
>;

export const createFinixTransactionResponseSchema = zSchema.object({
  companyID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  orderID: schemes.uuid().optional(),
  invoiceID: schemes.uuid().optional(),
  transactionType: zSchema.string(),
  amount: zSchema.number(),
  cardID: schemes.uuid(),
  description: zSchema.string(),
  transactionID: schemes.uuid(),
  lastFour: zSchema.string(),
});

export type TCreateFinixTransactionResponseSchema = zSchema.infer<
  typeof createFinixTransactionResponseSchema
>;
